<template>
  <PageContainer class="PageContainer" :breadcrumbs="breadcrumbs">
    <Top/>
  </PageContainer>
</template>

<script lang="ts">
import { useSeoMeta, definePageMeta, useHead, useRuntimeConfig } from '#imports'
import { defineNuxtComponent } from '#app'
import type { WithContext, WebSite } from 'schema-dts'
import Top from '@/components/Top'
import PageContainer from '@/containers/Page'

export default defineNuxtComponent({
  components: {
    Top,
    PageContainer,
  },
  setup() {
    const { public: { APP_ENV } } = useRuntimeConfig()
    /**
     * Setup Header
     */
    const title = 'トレカ通販ならカーナベル！TCG通販サイト'
    const description = "人気カードからコレクションまで豊富な在庫を状態別で販売！最短翌日午前中には手に入る。「納得価格」「状態別販売」「即日発送」でトレカライフを支えるカーナベル通販サイトです"
    useSeoMeta({
      title,
      description,
      ogTitle: title,
      ogDescription: description,
      robots: APP_ENV==='production' ? 'index,follow' :'noindex,nofollow',
      twitterSite: '@ka_nabell_pcg',
      ogSiteName: 'ポケカ販売ならカーナベル！',
      ogUrl: 'https://sell.ka-nabell.com/'
    })

    /**
     * Setup Page
     */
    definePageMeta({
      layout: 'simple'
    })

    const googleSchema: WithContext<WebSite> = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'カーナベル通販サイト',
      url: 'https://sell.ka-nabell.com/',
    }

    useHead({
      link: [
        {
          rel: 'canonical',
          href: 'https://sell.ka-nabell.com'
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify(googleSchema, null, '\t')
        }
      ]
    })

    const breadcrumbs = [
      {
        title: 'トレカ販売トップ',
      }
    ]

    return {
      breadcrumbs,
    }
  }
})
</script>

<style scoped>
.PageContainer {
  padding-top: 48px;
  background-image: url('https://assets.ka-nabell.com/selling-web/sell-top/top-background.png');
  background-size: cover;
}
</style>
